import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D426 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D426 - Data Management - Foundations</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 9.15 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Pretty fun course! There’s a lot of information, but it’s definitely
            worth soaking in since it helps with the next two courses (D427 and
            D326). The Zybooks material is pretty good, except for cardinality.
            I just watched some YouTube explanations for those.
          </p>
          <p>
            {" "}
            Here are some key things I remember from the OA:
            <ul>
              <li>
                Focus on the different types of databases and understand the
                differences and where they are better used (e.g., MongoDB,
                NoSQL, etc.).{" "}
              </li>
              <li>
                SQL basic statements, variable types, the 3 design phases, SQL
                sublanguages and what they do (this is important, there were a
                few questions on this).
              </li>
              <li>
                Learn the joins (inner join, left join, etc.) from this website:
                Wisc Online Database Joins.
              </li>
              <li>
                Understand primary key and foreign key. It’s such a simple
                concept, yet there were many questions on the OA about them. The
                explanations are short and very visual.
              </li>
            </ul>{" "}
          </p>
          <p>
            In summary, it’s a lot of information, but it’s a pretty easy
            course. There’s not much you need to byheart—it’s mostly about
            understanding the logic behind databases, and you should be good!
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D426;
